export default __webpack_public_path__ + "static/media/import-icon.85fd07da.svg";